var render, staticRenderFns
import script from "./MiniOauthRedirect.vue?vue&type=script&lang=js"
export * from "./MiniOauthRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b2bdd",
  null
  
)

export default component.exports